var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.list,"size":"small"}},[_c('div',{staticStyle:{"padding":"6px","text-align":"center","font-weight":"bold"},attrs:{"slot":"header"},slot:"header"},[_vm._v(" 配件详情 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }